<template>
  <div>
    <EmdPanel>
      <EmdPanelSection :title="$t('recipients.create.recipient')">
        <name-input
          v-if="isCpf || isLegacy"
          :recipient="recipient"
          :disabled="disabled"
          :nameInputIsInvalid.sync="nameInputIsInvalid"
          :vuelidate="vuelidate"
        />
        <email-input
          :recipient="recipient"
          :disabled="disabled"
        />
        <description-input
          :recipient="recipient"
          :disabled="disabled || !!locks.description"
        />
        <document-input
          :recipient="recipient"
          :disabled="disabled"
        />
        <template v-if="!isLegacy">
          <site-url-input
            :recipient="recipient"
            :disabled="disabled"
          />
          <trading-name-input
            v-if="!isCpf"
            :recipient="recipient"
            :disabled="disabled || !!locks.trading_name"
          />
          <company-name-input
            v-if="!isCpf"
            :recipient="recipient"
            :disabled="disabled"
          />
          <annual-revenue-input
            v-if="!isCpf"
            :recipient="recipient"
            :disabled="disabled || !!locks.annual_revenue"
          />
          <founding-date-input
            v-if="!isCpf"
            :recipient="recipient"
            :disabled="disabled || !!locks.founding_date"
          />
          <birthdate-input
            v-if="isCpf"
            :recipient="recipient"
            :disabled="disabled || !!locks.birth_date"
          />
          <ProfessionalOccupationInput
            v-if="isCpf"
            :recipient="recipient"
            :disabled="disabled || !!locks.professional_occupation"
          />
          <MotherNameInput
            v-if="isCpf"
            :recipient="recipient"
            :disabled="disabled || !!locks.mother_name"
          />
          <MonthlyIncomeInput
            v-if="isCpf"
            :recipient="recipient"
            :disabled="disabled || !!locks.monthly_income"
          />
          <div class="phone-container">
            <phone-type-input
              class="phone-type"
              :recipient="recipient"
              :disabled="disabled"
            />
            <phone-area-number-input
              class="phone-area"
              :recipient="recipient"
              :disabled="disabled"
            />
            <phone-number-input
              class="phone-number"
              :recipient="recipient"
              :disabled="disabled"
            />
          </div>
        </template>
      </EmdPanelSection>
    </EmdPanel>

    <EmdPanel v-if="!isLegacy && recipient.address">
      <EmdPanelSection :title="$t('address')">
        <address-section
          :canSearchZipCode="canSearchZipCode"
          :recipient.sync="recipient"
          :showSideBlock="false"
        />
      </EmdPanelSection>
    </EmdPanel>
  </div>
</template>

<script>
import { EmdPanel, EmdPanelSection } from 'emerald-vue/src/components'
import {
  NameInput,
  EmailInput,
  DescriptionInput,
  DocumentInput,
  AnnualRevenueInput,
  TradingNameInput,
  CompanyNameInput,
  PhoneAreaNumberInput,
  PhoneTypeInput,
  PhoneNumberInput,
  FoundingDateInput,
  SiteUrlInput,
  MotherNameInput,
  MonthlyIncomeInput,
  BirthdateInput,
  ProfessionalOccupationInput
} from './FormFields'
import AddressSection from './AddressSection.vue'
import { getState, feedbacks } from '@/utils/form.utils'
import { mapGetters } from 'vuex/dist/vuex.common.js'
export default {
  name: 'Recipient',
  components: {
    EmdPanel,
    EmdPanelSection,
    NameInput,
    EmailInput,
    DescriptionInput,
    DocumentInput,
    AnnualRevenueInput,
    CompanyNameInput,
    TradingNameInput,
    PhoneAreaNumberInput,
    PhoneTypeInput,
    PhoneNumberInput,
    FoundingDateInput,
    AddressSection,
    SiteUrlInput,
    MotherNameInput,
    MonthlyIncomeInput,
    BirthdateInput,
    ProfessionalOccupationInput
  },
  data: () => ({
    getState,
    feedbacks,
    nameInputIsInvalid: false
  }),
  props: {
    recipient: {
      type: Object,
      required: true
    },
    canSearchZipCode: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    isCpf: Boolean,
    vuelidate: Object,
    kyc: {
      type: Boolean,
      default: null
    },
    locks: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['canCreateRecipient']),
    isLegacy () {
      return this.kyc === null ? this.canCreateRecipient : !this.kyc
    }
  }
}
</script>

<style scoped>
.phone-container {
  display: flex;
  gap: 16px;
}
.phone-type {
  width: 125px;
  text-wrap: nowrap;
}
.phone-area {
  width: 65px;
}
.phone-number {
  width: 100%;
}
</style>

<i18n>
  {
    "pt-BR": {
      "address": "Endereço"
    },
    "en-US": {
      "address": "Address"
    }
  }
</i18n>
